(function() {
  App.angularApp.directive('mfNumber', [
    (function(_this) {
      return function() {
        return {
          require: 'ngModel',
          link: function(scope, element, attrs, ngModel) {
            var decimalPlaces, formatNumber, formatter, parseNumber, updateView;
            attrs.$set('ngTrim', 'false');
            decimalPlaces = parseInt(attrs.mfNumber) || 0;
            formatter = function(str, isNum) {
              str = String(Number(str || 0) / (isNum ? 1 : Math.pow(10, decimalPlaces)));
              str = str === '0' ? '0.0' : str;
              str = str.split('.');
              str[1] = str[1] || '0';
              return str[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') + (decimalPlaces > 0 ? '.' + (str[1] + '0'.repeat(Math.max(0, decimalPlaces - str[1].length))) : '');
            };
            updateView = function(val) {
              return scope.$applyAsync(function() {
                var caretPosition;
                caretPosition = element[0].selectionStart;
                if (val.length > ngModel.$viewValue.length) {
                  caretPosition += 1;
                } else if (val.length < ngModel.$viewValue.length) {
                  caretPosition -= 1;
                }
                ngModel.$setViewValue(val || '');
                ngModel.$render();
                return element[0].setSelectionRange(caretPosition, caretPosition);
              });
            };
            parseNumber = function(val) {
              var modelString, newSign, newVal, sign, valString, viewVal;
              modelString = formatter(ngModel.$modelValue, true);
              sign = {
                pos: /[+]/.test(val),
                neg: /[-]/.test(val)
              };
              sign.has = sign.pos || sign.neg;
              sign.both = sign.pos && sign.neg;
              if (!val || sign.has && val.length === 1 || ngModel.$modelValue && Number(val) === 0) {
                newVal = !val || ngModel.$modelValue && (Number() === 0 ? '' : val);
                if (ngModel.$modelValue !== newVal) {
                  updateView(newVal);
                }
                return '';
              } else {
                valString = String(val || '');
                newSign = sign.both && ngModel.$modelValue >= 0 || !sign.both && (sign.neg ? '-' : '');
                newVal = valString.replace(/[^0-9]/g, '');
                viewVal = newSign + formatter(angular.copy(newVal));
                if (modelString !== valString) {
                  updateView(viewVal);
                }
                return (Number(newSign + newVal) / Math.pow(10, decimalPlaces)) || 0;
              }
            };
            formatNumber = function(val) {
              var str;
              if (val) {
                str = String(val).split('.');
                str[1] = str[1] || '0';
                val = str[0] + (decimalPlaces > 0 ? '.' + (str[1].length === 1 ? str[1] + '0' : str[1]) : '');
              }
              return parseNumber(val);
            };
            ngModel.$parsers.push(parseNumber);
            return ngModel.$formatters.push(formatNumber);
          }
        };
      };
    })(this)
  ]);

}).call(this);
